import { computed } from "vue";
import { BlockDef } from "./block.interfaces";
import { arrayField, createBlock } from "./blockBuilder";
import { useDefaultColors } from "./useDefaultColors";
import {
    ActionsWithSharedBorders,
    type ActionsWithSharedBordersProps,
} from "@/views/blocks/tables/tables";
import img24Src from "@/views/blocks/shared/images/24.svg";

export function useTables() {
    const { colorDefaults } = useDefaultColors();

    const actionsWithSharedBordersBlock = computed<BlockDef>(() =>
        createBlock<ActionsWithSharedBordersProps>({
            typeId: "ActionsWithSharedBorders",
            type: "tables",
            name: "Actions with shared borders",
            component: ActionsWithSharedBorders,
        })
            .withArrayField(
                "actions",
                arrayField(
                    "Cell",
                    "items",
                    {
                        imageSrc: {
                            label: "Image Source",
                            type: "image",
                        },
                        imageAlt: {
                            label: "Image Alt Text",
                            type: "text",
                        },
                        title: {
                            label: "Title",
                            type: "text",
                        },
                        description: {
                            label: "Description",
                            type: "html",
                        },
                        link: {
                            label: "Link URL",
                            type: "text",
                        },
                    },
                    [
                        {
                            imageSrc: img24Src,
                            imageAlt: "Image 1",
                            title: "Smart Automation",
                            description:
                                "Automate repetitive tasks with intelligent systems that learn and adapt to your business needs. Save time and reduce errors while boosting productivity.",
                            link: "#",
                        },
                        {
                            imageSrc: img24Src,
                            imageAlt: "Image 2",
                            title: "Advanced Analytics",
                            description:
                                "Gain valuable insights from your data with powerful analytics tools. Visualize trends and make data-driven decisions to grow your business effectively.",
                            link: "#",
                        },
                        {
                            imageSrc: img24Src,
                            imageAlt: "Image 3",
                            title: "Seamless Integration",
                            description:
                                "Connect all your existing tools and platforms with our solution. Our API-first approach ensures compatibility and streamlines your workflow.",
                            link: "#",
                        },
                        {
                            imageSrc: img24Src,
                            imageAlt: "Image 4",
                            title: "Enterprise Security",
                            description:
                                "Protect your data with enterprise-grade security features. Our platform includes encryption, multi-factor authentication, and regular security audits.",
                            link: "#",
                        },
                        {
                            imageSrc: img24Src,
                            imageAlt: "Image 5",
                            title: "Request Time Off",
                            description:
                                "Easily manage employee time-off requests with our intuitive interface. Track vacation days and absences to maintain optimal staffing levels.",
                            link: "#",
                        },
                        {
                            imageSrc: img24Src,
                            imageAlt: "Image 6",
                            title: "Payroll Management",
                            description:
                                "Streamline payroll processes with automated calculations, tax withholdings, and direct deposits. Ensure accurate and timely payments to employees.",
                            link: "#",
                        },
                    ]
                )
            )
            .withStyleFields([
                colorDefaults.value.background,
                colorDefaults.value.text,
                colorDefaults.value.brand,
            ])
            .build()
    );

    return {
        blocks: computed(() => [actionsWithSharedBordersBlock.value]),
    };
}
